import { Component, Injector, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseRoute } from '../../../shared/components/base.route';
import { QuestionnaireService } from '../../../shared/services/questionnaire.service';
import { GoalValidationService } from '../../../shared/services/goalvalidation.service';
@Component({
  selector: 'recommendation',
  template: require('./recommendation.component.html'),
  styles: [require('./recommendation.component.scss')]
})
export class RecommendationComponent extends BaseRoute {
  @ViewChild('focusItem') focusItem;
  @ViewChild('headerFocus') headerFocus;

  bankRate$: Observable<number>;
  portfolioSummary$: Observable<any>;
  portfolioAllocations$: Observable<any>;
  assetBreakdown$: Observable<any>;
  historicalReturns$: Observable<any>;
  recommendationHeaders$: Observable<any>;
  isLoading$: Observable<any>;

  constructor(injector: Injector,
    questionnaire: QuestionnaireService,
    goalValidation: GoalValidationService) {
    super(injector);
    this.questionnaire = questionnaire;
    this.goalValidation = goalValidation;
    this.hasFocused = false;
    this.hasFocusedHeader = false;
    this.hasFocusedItem = false;
  }

  ngAfterViewChecked() {
    if (((this.isLoading$) && this.focusItem && !this.hasFocusedItem)) {
      this.focusItem.nativeElement.focus();
      this.hasFocusedItem = true;
      this.hasFocusedHeader = false;
    }
    if (this.recommendationHeaders$ && !this.hasFocused && this.headerFocus) {
      this.headerFocus.nativeElement.focus();
      this.hasFocused = true;
    }
    if (!this.recommendationHeaders$ && !(this.isLoading$)) {
      this.hasFocusedHeader = false;
      this.hasFocusedItem = false;
    }
  }

  ngOnInit() {
    if (this.flowManager.goalSession) {
      if (this.flowManager.goalSession.isCashVested == null) {
        const isCashVested = this.flowManager.goalSession.cashAllocation === 'cashEnhanced';
        this.flowManager.setIsCashVested(isCashVested);
      }
      if (this.flowManager.goalSession.isDirty == null) {
        this.flowManager.goalSession = { ...this.flowManager.goalSession, isDirty: true };
      }
    }

    this.bankRate$ = this.questionnaire.bankRate;
    this.portfolioSummary$ = this.questionnaire.portfolioSummary$;
    this.portfolioAllocations$ = this.questionnaire.portfolioAllocationsTable$;
    this.assetBreakdown$ = this.questionnaire.assetBreakdown$;
    this.historicalReturns$ = this.questionnaire.historicalReturns$;
    this.recommendationHeaders$ = this.questionnaire.recommendationHeaders$;
    this.isLoading$ = this.questionnaire.isLoading$;
    this.questionnaire.updatePortfolio();
  }

  onOpenAccount() {
    this.isUpdating = true;
    this.goalValidation.updateGoalSession()
      .then(resp => {
        this.appActions.deleteData('StepCompleted');
        const routerOptions = { queryParamsHandling: 'preserve' };
        if (resp.statusCode === 'SUCCESS') {
          if (this.flowManager.isAuthed) {
            this.router.navigate(['/select-account-type'], routerOptions);
            return;
          }
          this.router.navigate(['/get-started'], routerOptions);
        } else {
          console.error('updateGoalSession Error:', resp);
          this.updateGoalSessionError = true;
        }
        this.isUpdating = false;
      })
      .catch(err => {
        this.isUpdating = false;
        console.error('updateGoalSession Error:', err);
        this.updateGoalSessionError = true;
      });
  }
}
